import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HeaderComponent } from './header/header.component';
import { AdminHeaderComponent } from './admin-header/admin-header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DonrSectionComponent } from './donr-section/donr-section.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PartnershipCenterComponent } from './partnership-center/partnership-center.component';
import { ReportsHeaderComponent } from './reports-header/reports-header.component';

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    DonrSectionComponent,
    PartnershipCenterComponent,
    AdminHeaderComponent,
    ReportsHeaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    FontAwesomeModule
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
    DonrSectionComponent,
    PartnershipCenterComponent,
    AdminHeaderComponent,
    ReportsHeaderComponent
  ]
})
export class ComponentsModule { }
